module.exports = __webpack_public_path__ + "img/tz50x.c8c03b58.jpg";